import { render, staticRenderFns } from "./InscricaoAtividades.vue?vue&type=template&id=701f591a&"
import script from "./InscricaoAtividades.vue?vue&type=script&lang=js&"
export * from "./InscricaoAtividades.vue?vue&type=script&lang=js&"
import style0 from "./InscricaoAtividades.vue?vue&type=style&index=0&id=701f591a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports